import * as S from "../LegendItem.style";

interface LegendItemProps {
  ledColor?: "red" | "yellow" | "green" | "gray";
  title: string;
  onContextMenu?: (event: React.MouseEvent, target: any) => void;
}

export const LedLegendItem = ({
  ledColor,
  title,
  onContextMenu,
}: LegendItemProps) => {
  return (
    <S.LegendItem
      onContextMenu={(e) => onContextMenu?.(e, "/equipment/gas-turbine/0")}
    >
      <S.LedBox $ledColor={ledColor} />
      <S.LegendTit>{title}</S.LegendTit>
    </S.LegendItem>
  );
};
